<template>
  <div>
    <div class="admin_topbar">
      <div class="admin_topbar_mainblock">
        <h1 class="header" :class="{ 'inner-header': isInner }">Склады</h1>
      </div>
    </div>
    <div class="view">
      <div class="columns_first">
        <div class="indicators_block col">
          <div class="indicator">
            <p class="indicator__text">ОБЩИЙ ОСТАТОК</p>
            <div class="indicator__item">{{ totalOstatok }} ₽</div>
          </div>
        </div>
        <div class="table_block col">
          <table>
            <thead>
              <tr>
                <th>СКЛАД</th>
                <th>СУММЫ</th>
              </tr>
              <tr v-for="(project, index) in projects" :key="index">
                <td>{{ project.name }}</td>
                <td>
                  {{
                    (
                      getProjectAllIncome(project) -
                      getProjectAllOutcome(project)
                    ).toLocaleString()
                  }}
                  ₽
                </td>
              </tr>
            </thead>
          </table>
        </div>
      </div>
      <p class="nav_links">
        <span class="nav_links__item is-active">Операции</span>
        <span class="nav_links__item">Остатки</span>
      </p>
      <div class="plus_button__wrapper">
        <div class="col1 col plus_button">
          <OrangaPlus></OrangaPlus> ПОСТУПЛЕНИЕ
        </div>
        <div class="col2 col plus_button">
          <OrangaPlus></OrangaPlus> СПИСАНИЕ
        </div>
        <div class="col3 col plus_button">
          <OrangaPlus></OrangaPlus> ПЕРЕМЕЩЕНИЕ
        </div>
      </div>
      <div class="events_block">
        <table>
          <thead>
            <tr>
              <th>ДАТА</th>
              <th>НОМЕР</th>
              <th>ЗАКАЗ</th>
              <th>ТИП ОПЕРАЦИИ</th>
              <th>СКЛАД</th>
              <th>СУММА</th>
            </tr>
            <tr v-for="(event, index) in allEvents" :key="index">
              <td>{{ event.date }}</td>
              <td>{{ event.id }}</td>
              <td>—</td>
              <td v-html="getEventTypeText(event.type)"></td>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import OrangaPlus from "../components/Icons/OrangaPlus.vue";
import ProjectService from "../services/projectService";

export default {
  data: () => {
    return {
      projects: [],
    };
  },
  components: {
    OrangaPlus,
  },
  mounted() {
    this.initProjects();
  },
  watch: {},
  computed: {
    totalOstatok: function () {
      let res = 0;
      this.projects.forEach((item) => {
        res =
          res +
          (this.getProjectAllIncome(item) - this.getProjectAllOutcome(item));
      });
      return res;
    },
    allEvents: function () {
      let res = [];
      this.projects.forEach((project) => {
        project.events.forEach((event) => {
          res.push({
            date: event.date,
            id: event.id,
            type: event.type,
            //sklad: event
          });
        });
      });
      return res;
    },
  },
  methods: {
    async initProjects() {
      if (localStorage.getItem("projectsFilter")) {
        this.projectsFilter = JSON.parse(
          localStorage.getItem("projectsFilter")
        );
      }
      let resp = await fetch("/backend/contractors.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("isLogged"),
        },
        body: JSON.stringify({
          action: "getContractorsLight",
        }),
      });
      const contractors = await resp.json();
      this.contractors = contractors;

      // resp = await fetch("/backend/projects.php", {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //     authorization: localStorage.getItem("isLogged"),
      //   },
      //   body: JSON.stringify({
      //     action: "getProjectsWithWarehouseData",
      //   }),
      // });
      // const projects = await resp.json();
      this.projects = ProjectService.getProjects();
    },
    getProjectAllIncome(project) {
      return project.events.reduce(
        (acc, i) => (acc += i.type == "income" ? this.countSumm(i) : 0),
        0
      );
    },
    getProjectAllOutcome(project) {
      return project.events.reduce(
        (acc, i) => (acc += i.type == "outcome" ? this.countSumm(i) : 0),
        0
      );
    },
    countSumm(event) {
      return event.elements.reduce((acc, i) => (acc += i.cost * i.quantity), 0);
    },
    getEventTypeText(event) {
      let res = "";
      if (event === "income") {
        res = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
            "<g opacity=\"0.5\">\n" +
            "<path d=\"M6.44922 12.1501L9.59922 9.0001L6.44922 5.8501\" stroke=\"#2C2738\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
            "<path d=\"M1.19922 9H9.59922\" stroke=\"#2C2738\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
            "<path d=\"M9.60156 2.3999H13.8016C13.9607 2.3999 14.1133 2.46312 14.2258 2.57564C14.3383 2.68816 14.4016 2.84077 14.4016 2.9999V14.9999C14.4016 15.159 14.3383 15.3116 14.2258 15.4242C14.1133 15.5367 13.9607 15.5999 13.8016 15.5999H9.60156\" stroke=\"#2C2738\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
            "</g>\n" +
            "</svg>\n Поступление";
      }
      else {
        res = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
            "<g opacity=\"0.5\">\n" +
            "<path d=\"M12.9805 5.36548L16.6151 9.00009L12.9805 12.6347\" stroke=\"#2C2738\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
            "<path d=\"M6.92188 9H16.6142\" stroke=\"#2C2738\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
            "<path d=\"M6.92127 16.6153H2.07512C1.89151 16.6153 1.71542 16.5424 1.58558 16.4125C1.45575 16.2827 1.38281 16.1066 1.38281 15.923V2.07683C1.38281 1.89322 1.45575 1.71713 1.58558 1.58729C1.71542 1.45746 1.89151 1.38452 2.07512 1.38452H6.92127\" stroke=\"#2C2738\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
            "</g>\n" +
            "</svg>\n Списание";
      }
      return res;
    },
  },
};
</script>

<style scoped>
.columns_first {
  display: flex;
}
.table_block {
  flex-grow: 1;
}
.nav_links {
  margin-top: 40px;
}
.plus_button__wrapper {
  margin-top: 50px;
}
.plus_button__wrapper .col {
  margin-right: 40px;
}
</style>
